import projectConfig from '@/config/config';
const baseURL = projectConfig.baseURL;
const api = {
  queryTemplate: baseURL + '/trade/template/open/templateQuery',
  queryPurchaseContractPrintDetail: baseURL + '/trade/template/open/contractPurchasePrintVTwo',
  queryContractIfExpiration: baseURL + '/trade/template/open/ifExpiration',
  signConfirmContract: baseURL + '/trade/template/open/confirmContract'
};

export default api;
